













import Vue from "vue";
import { DropdownPlugin } from "bootstrap-vue";

Vue.use(DropdownPlugin);

export default Vue.extend({
  name: "HeaderTopPanelLanguageSelect",
  data() {
    return { languages: ["en", "hu"], selectedLanguage: this.$i18n.locale };
  },
  watch: {
    selectedLanguage(val) {
      this.$i18n.locale = val;
      this.$moment.locale(val);
    }
  }
});
